const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.2012 19.3519C16.2012 19.3519 16.2012 19.3024 16.2012 19.2034C16.2012 19.1043 16.2546 19.0281 16.3613 18.9748H25.1119C24.2273 18.3118 23.6821 17.4622 23.4762 16.4259C23.4762 16.4183 23.4762 16.4069 23.4762 16.3917C23.4762 16.3764 23.4724 16.365 23.4647 16.3574C23.4647 16.2659 23.5295 16.2202 23.6592 16.2202H23.6935C23.7621 16.2202 23.8079 16.224 23.8308 16.2316C23.8536 16.2393 23.8765 16.2545 23.8994 16.2774C23.9223 16.3002 23.9337 16.3345 23.9337 16.3802C23.9337 16.4259 23.9452 16.4869 23.968 16.5631C23.9909 16.6393 24.0214 16.7345 24.0595 16.8488C24.2273 17.3594 24.5056 17.8166 24.8946 18.2204C25.2835 18.6243 25.7372 18.91 26.2558 19.0776C26.3244 19.1005 26.3587 19.1424 26.3587 19.2034C26.3587 19.2491 26.3397 19.2834 26.3015 19.3062C26.2634 19.3291 26.1719 19.3672 26.027 19.4205C25.8821 19.4739 25.7372 19.5462 25.5923 19.6377C25.2797 19.8358 25.0089 20.0644 24.7802 20.3235C24.5514 20.5825 24.3798 20.8378 24.2654 21.0893C24.151 21.3407 24.071 21.5312 24.0252 21.6607C23.9795 21.7903 23.949 21.9084 23.9337 22.0151C23.9185 22.0913 23.8994 22.137 23.8765 22.1522C23.8536 22.1675 23.7926 22.1789 23.6935 22.1865C23.541 22.1865 23.4647 22.1446 23.4647 22.0608C23.4647 22.0074 23.4838 21.9122 23.5219 21.775C23.7659 20.8149 24.2959 20.0339 25.1119 19.432H16.3613C16.2546 19.3786 16.2012 19.3024 16.2012 19.2034V19.3519Z",
  fill: "#1E3F6B"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M3.9707 19.3526C3.9707 19.3526 3.9707 19.3031 3.9707 19.204C3.9707 19.1049 4.07602 19.0287 4.28666 18.9754H17.399C17.6246 19.0364 17.7375 19.1126 17.7375 19.204C17.7375 19.2954 17.6246 19.3716 17.399 19.4326H4.28666C4.07602 19.3793 3.9707 19.3031 3.9707 19.204V19.3526Z",
  fill: "#1E3F6B"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.2012 19.2034C16.2012 19.3024 16.2012 19.3519 16.2012 19.3519V19.2034ZM16.2012 19.2034C16.2012 19.1043 16.2546 19.0281 16.3613 18.9748H25.1119C24.2273 18.3118 23.6821 17.4622 23.4762 16.4259C23.4762 16.4183 23.4762 16.4069 23.4762 16.3917C23.4762 16.3764 23.4724 16.365 23.4647 16.3574C23.4647 16.2659 23.5295 16.2202 23.6592 16.2202H23.6935C23.7621 16.2202 23.8079 16.224 23.8308 16.2316C23.8536 16.2393 23.8765 16.2545 23.8994 16.2774C23.9223 16.3002 23.9337 16.3345 23.9337 16.3802C23.9337 16.4259 23.9452 16.4869 23.968 16.5631C23.9909 16.6393 24.0214 16.7345 24.0595 16.8488C24.2273 17.3594 24.5056 17.8166 24.8946 18.2204C25.2835 18.6243 25.7372 18.91 26.2558 19.0776C26.3244 19.1005 26.3587 19.1424 26.3587 19.2034C26.3587 19.2491 26.3397 19.2834 26.3015 19.3062C26.2634 19.3291 26.1719 19.3672 26.027 19.4205C25.8821 19.4739 25.7372 19.5462 25.5923 19.6377C25.2797 19.8358 25.0089 20.0644 24.7802 20.3235C24.5514 20.5825 24.3798 20.8378 24.2654 21.0893C24.151 21.3407 24.071 21.5312 24.0252 21.6607C23.9795 21.7903 23.949 21.9084 23.9337 22.0151C23.9185 22.0913 23.8994 22.137 23.8765 22.1522C23.8536 22.1675 23.7926 22.1789 23.6935 22.1865C23.541 22.1865 23.4647 22.1446 23.4647 22.0608C23.4647 22.0074 23.4838 21.9122 23.5219 21.775C23.7659 20.8149 24.2959 20.0339 25.1119 19.432H16.3613C16.2546 19.3786 16.2012 19.3024 16.2012 19.2034ZM3.9707 19.204C3.9707 19.3031 3.9707 19.3526 3.9707 19.3526V19.204ZM3.9707 19.204C3.9707 19.1049 4.07602 19.0287 4.28666 18.9754H17.399C17.6246 19.0364 17.7375 19.1126 17.7375 19.204C17.7375 19.2954 17.6246 19.3716 17.399 19.4326H4.28666C4.07602 19.3793 3.9707 19.3031 3.9707 19.204Z",
  stroke: "#1E3F6B",
  strokeWidth: 0.5
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 12 15)",
  stroke: "#0081CC"
});

const SvgEquationOperator1 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationOperator1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-operator-1.862a84cf.svg";
export { ForwardRef as ReactComponent };